import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(".book .article").find(".article-reference, .person-reference, .glossary-reference").contents().unwrap();
  }
}
